import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@ferris/react/components/cards';
import classNames from 'classnames';
import LypHeader from '../LypHeader';
import Footer from '../../Footer';

function EgTemplate(props) {
    const {
        children,
        history,
        referrer
    } = props;
    return (
        <div className="ulx-antialias eg">
            <nav className={classNames('navbar')}>
                <LypHeader
                    history={history}
                    referrer={referrer}
                    hideCta
                />
            </nav>
            <div className="ulx--eg-container">
                <Card
                    elevation="0"
                    theme="default"
                >
                    <CardContent
                        collapsePadding={false}
                        separatorBottom={false}
                        separatorTop={false}
                    >
                        {children}
                    </CardContent>
                </Card>
            </div>
            <Footer />
        </div>
    );
}

EgTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired
    }).isRequired,
    referrer: PropTypes.string.isRequired
};

export default EgTemplate;
